import { createAuthClient } from "better-auth/react"
import { twoFactorClient } from "better-auth/plugins"

export const authClient = createAuthClient({
    baseURL: "",
    basePath: "/api/auth",
    plugins: [twoFactorClient()]
})

export const {
    signIn,
    signUp,
    signOut,
    useSession,
    forgetPassword,
    resetPassword,
} = authClient